import { assertNever } from '../assert/assertNever.js'
import { SparkDomain } from '../types/SparkDomain.js'

export interface AlchemyRpcUrlParams {
  domain: SparkDomain
  alchemyApiKey: string
}

export function getAlchemyRpcUrl({ domain, alchemyApiKey }: AlchemyRpcUrlParams): string {
  switch (domain) {
    case 'mainnet':
      return `https://eth-mainnet.g.alchemy.com/v2/${alchemyApiKey}`
    case 'base':
      return `https://base-mainnet.g.alchemy.com/v2/${alchemyApiKey}`
    case 'gnosis':
      return `https://gnosis-mainnet.g.alchemy.com/v2/${alchemyApiKey}`
    case 'arbitrum':
      return `https://arb-mainnet.g.alchemy.com/v2/${alchemyApiKey}`
    case 'optimism':
      return `https://opt-mainnet.g.alchemy.com/v2/${alchemyApiKey}`
    case 'worldchain':
      return `https://worldchain-mainnet.g.alchemy.com/v2/${alchemyApiKey}`
    case 'unichain':
      return `https://unichain-mainnet.g.alchemy.com/v2/${alchemyApiKey}`
    case 'avalanche':
      return `https://avax-mainnet.g.alchemy.com/v2/${alchemyApiKey}`
    case 'sepolia':
      return `https://eth-sepolia.g.alchemy.com/v2/${alchemyApiKey}`
    case 'baseSepolia':
      return `https://base-sepolia.g.alchemy.com/v2/${alchemyApiKey}`
    default:
      assertNever(domain)
  }
}
